module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-navbar'), _vm._v(" "), _c('c-content', [_c('div', {
    staticClass: "page"
  }, [(_vm.isPaySuccess) ? _c('div', {
    staticClass: "weui-msg"
  }, [_c('div', {
    staticClass: "weui-msg__icon-area"
  }, [_c('i', {
    staticClass: "weui-icon_msg",
    class: [_vm.isPaySuccess ? 'weui-icon-success' : 'weui-icon-warn']
  })]), _vm._v(" "), _c('div', {
    staticClass: "weui-msg__text-area"
  }, [_c('h2', {
    staticClass: "weui-msg__title"
  }, [_vm._v(_vm._s(_vm._f("currency2")(_vm.price)))]), _vm._v(" "), _c('p', {
    staticClass: "weui-msg__desc"
  }, [_vm._v(_vm._s(_vm.payStatus.status == 'success' ? '支付成功' : '支付失败'))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-msg__opr-area"
  }, [(_vm.isPaySuccess) ? _c('c-footer', [_c('c-button', {
    attrs: {
      "btn-type": "default"
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToMarket($event)
      }
    }
  }, [_vm._v("商城首页")]), _vm._v(" "), _c('c-button', {
    nativeOn: {
      "click": function($event) {
        _vm.goToOrderList($event)
      }
    }
  }, [_vm._v("查看订单")])], 1) : _vm._e()], 1)]) : _vm._e()])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffb86540","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pay-status/index.vue
// module id = 1077
// module chunks = 2